
import { loadStripe } from '@stripe/stripe-js';

// Get the Stripe publishable key from environment variables (now set in vite.config.ts)
const stripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;

// Comprehensive logging for Stripe Publishable Key diagnostics
console.group('Stripe Publishable Key Diagnostics');
console.log('Stripe Key Present:', !!stripeKey);
if (stripeKey) {
  console.log('Stripe Key Length:', stripeKey.length);
  console.log('Stripe Key Prefix:', stripeKey.substring(0, 7));
  console.log('Stripe Key Mode:', stripeKey.startsWith('pk_live_') ? 'LIVE' : 'TEST');
} else {
  console.error('❌ VITE_STRIPE_PUBLISHABLE_KEY is not available');
  console.log('Check vite.config.ts configuration');
}
console.log('Current Environment:', import.meta.env.MODE);
console.groupEnd();

// Only initialize Stripe if we have a valid key
let stripePromise: Promise<any> | null = null;

if (stripeKey && stripeKey.trim() !== '') {
  stripePromise = loadStripe(stripeKey);
  console.log('✅ Stripe initialized successfully in', stripeKey.startsWith('pk_live_') ? 'LIVE' : 'TEST', 'mode');
} else {
  console.error('❌ Cannot initialize Stripe: Missing publishable key');
  stripePromise = Promise.resolve(null);
}

export { stripePromise };
